import React, { useEffect, useState } from 'react'
import "react-datepicker/dist/react-datepicker.css";
import ClientModel, { ClientInvestmentDetail, AddressModel } from '../clients/models/ClientModel';
import Select from 'react-select'
import DDOption from '../../shared/models/DropdownModels.ts';
import axios from 'axios';
import SKAlerts, { CreateAlert } from '../../shared/common-alerts/SKAlerts.jsx';
import { ConvertArrayToXML, getStorageValues } from '../../shared/CommonFunctions.jsx';
import DatePicker from 'react-datepicker';
import ClientInvestmentGrid from './ClientInvestmentGrid.jsx';
import * as Icons from "react-feather";
import { getApiBaseUrl } from '../../utils/apiConfig.js';
import { useMasterDataBatch } from '../../utils/useMasterData';

function EditClient({ ClientData, ClientAddressData, sendDataToParent, sendAddressDataToParent }) {
  const [getEditClient, setEditClient] = useState(new ClientModel() || []);
  const [getClientAddress, setClientAddress] = useState(new AddressModel() || []);
  const [getClientInvestment, setClientInvestment] = useState([]);

  const [selectedClientCompanyTypeOption, setSelectedClientCompanyTypeOption] = useState([]);
  const [getClientCompanyTypeOptions, setClientCompanyTypeOptions] = useState(new DDOption() || []);

  const [selectedClientCompanyOption, setSelectedClientCompanyOption] = useState([]);
  const [getClientCompanyOptions, setClientCompanyOptions] = useState(new DDOption() || []);

  const [selectedTaxStatusOption, setSelectedTaxStatusOption] = useState([]);
  const [selectedModeOfHoldingOption, setSelectedModeOfHoldingOption] = useState([]);
  const [selectedClientRatingsOption, setSelectedClientRatingsOption] = useState([]);
  const [selectedTitleOption, setSelectedTitleOption] = useState([]);
  const [selectedGenderOption, setSelectedGenderOption] = useState([]);
  const [selectedFamilyHeadOption, setSelectedFamilyHeadOption] = useState([]);


  const [familyHeadChanged, setfamilyHeadChanged] = useState(false);
  
  const [familyHeadOptions, setFamilyHeadOptions] = useState([]);
  const [getShowTitle, setShowTitle] = useState(false);

  const [alert, setAlert] = useState(null);

  const [getDateOfAniversory, setDateOfAniversory] = useState(null);
  const [getDateOfBirth, setDateOfBirth] = useState(null);

  const [getPinNumber, setPinNumber] = useState('');
  const [getAnnualIncome, setAnnualIncome] = useState('');
  const [getGrossAnnualIncome, setGrossAnnualIncome] = useState('');
  const [getNetWorth, setNetWorth] = useState('');
  const [isDataInitialized, setIsDataInitialized] = useState(false);
  const [getMobileNumber, setMobileNumber] = useState('');

  // Fetch master data for dropdowns
  const { dataMap: masterData, loading: masterLoading } = useMasterDataBatch([
    'taxStatus',
    'modeOfHolding',
    'clientRating',
    'personTitle',
    'gender'
  ]);

  const TaxStatusOptions = masterData.taxStatus || [];
  const ModeOfHoldingOptions = masterData.modeOfHolding || [];
  const ClientRatingsOptions = masterData.clientRating || [];
  const PersonTitleOptions = masterData.personTitle || [];
  const GenderOptions = masterData.gender || [];

  function handleChangeDropdown(selectedOption, element) {
    if (element.name === "TaxStatusId") {
      setSelectedTaxStatusOption(selectedOption)
      if (selectedOption) {
        if (selectedOption.label === "Individual") {
          setShowTitle(true);
        } else {
          setShowTitle(false);
        }
      } else { setShowTitle(false); }
      if(selectedOption !== null){
        sendDataToParent({
              ...ClientData,
              TaxStatusId: selectedOption.value
          });
      } else {
        sendDataToParent({
              ...ClientData,
              TaxStatusId: null
          });
      }
    } else if (element.name === "TitleId") {
      setSelectedTitleOption(selectedOption);
      if(selectedOption !== null){
        sendDataToParent({
              ...ClientData,
              TitleId: selectedOption.value
          });
      } else {
        sendDataToParent({
              ...ClientData,
              TitleId: null
          });
      }
    } else if (element.name === "GenderId") {
      setSelectedGenderOption(selectedOption);
      if(selectedOption !== null){
        sendDataToParent({
              ...ClientData,
              GenderId: selectedOption.value
          });
      } else {
        sendDataToParent({
              ...ClientData,
              GenderId: null
          });
      }
    } else if (element.name === "FamilyHeadId") {
      setfamilyHeadChanged(true);
      setSelectedFamilyHeadOption(selectedOption);
      if (selectedOption !== null) {
        sendDataToParent({
          ...ClientData,
          FamilyHeadId: selectedOption.value
        });
      } else {
        sendDataToParent({
          ...ClientData,
          FamilyHeadId: null
        });
      }
    } else if (element.name === "ModeOfHoldingId") {
      setSelectedModeOfHoldingOption(selectedOption);
      if(selectedOption !== null){
        sendDataToParent({
              ...ClientData,
              ModeOfHoldingId: selectedOption.value
          });
      } else {
        sendDataToParent({
              ...ClientData,
              ModeOfHoldingId: null
          });
      }
    } else if (element.name === "ClientRatingsId") {
      setSelectedClientRatingsOption(selectedOption);
      if(selectedOption !== null){
        sendDataToParent({
              ...ClientData,
              ClientRatingsId: selectedOption.value
          });
      } else {
        sendDataToParent({
              ...ClientData,
              ClientRatingsId: null
          });
      }
    } else if (element.name === "ClientCompanyId") {
      setSelectedClientCompanyOption(selectedOption);
    } else if (element.name === "ClientCompanyTypeId") {
      setSelectedClientCompanyTypeOption(selectedOption);
      fetchClientCompany(selectedOption);
    }
  };
  const fetchClientCompany = async (cc) => {
    try {

      let selectedCompanyType = {
        ClientCompanyTypeId: cc === null || cc === undefined ? null : cc.value,
        UserId: getStorageValues('userId')
      };
      const response = await axios.get(getApiBaseUrl() + "/clientCompanybytype", { params: selectedCompanyType });
      if (response.status === 200) {
        setClientCompanyDropdownData(response.data.data[0]);
      }
    } catch (error) {
      console.log(error);
    }
  };

  function setClientCompanyDropdownData(cct) {
    let allModuleOpt = [];
    allModuleOpt = cct.map(p => ({ value: p.ClientCompanyId, label: p.ClientCompanyName, name: "ClientCompany", description: '', isFixed: false, isDisabled: false, groupId: null }))
    setClientCompanyOptions(allModuleOpt);
    setSelectedClientCompanyOption(null);
  }

  const fetchClientCompanyType = async () => {
    try {
      const response = await axios.get(getApiBaseUrl() + "/clientCompanyTypelist");
      if (response.status === 200) {
        setClientCompanyTypeDropdownData(response.data.data[0]);
      }
    } catch (error) {
      console.log(error);
    }
  };

  function setClientCompanyTypeDropdownData(cct) {
    let allModuleOpt = [];
    allModuleOpt = cct.map(p => ({ value: p.ClientCompanyTypeId, label: p.ClientCompanyTypeName, name: "ClientCompanyType", description: '', isFixed: false, isDisabled: false, groupId: null }))
    setClientCompanyTypeOptions(allModuleOpt);
  }

  const fetchFamilyHead = async () => {
    try {
      let dropdownDetails = {
        UserId: localStorage.getItem('userId'),
        IsForDropodown: 1
      };
      const response = await axios.get(getApiBaseUrl() + "/familyHeadfdd", {
        params: dropdownDetails
      });
      if (response.status === 200) {
        setFamilyHeadDropdownData(response.data.data[0]);
      }
    } catch (error) {
      console.log(error);
    }
  };

  function setFamilyHeadDropdownData(cct) {
    let allFamilyHeadOpt = [];
    allFamilyHeadOpt = cct.map(p => ({ value: p.ClientId, label: p.ClientName, name: "FamilyHead", description: '', isFixed: false, isDisabled: false, groupId: null }))
    setFamilyHeadOptions(allFamilyHeadOpt);
    if(familyHeadChanged === false){
      setSelectedFamilyHeadOption(allFamilyHeadOpt.filter(x => x.value === ClientData.FamilyHeadId));
    }
  };

  function handleChange(e, dateName) {
    let name, value;
    if(dateName === undefined){
      name = e.currentTarget.name;
      value = e.currentTarget.value;
    } else {
      name = dateName;
      value = e;
    }

     if(name === "MobileNumber"){
        if (/^\d*$/.test(value)) {
          setMobileNumber(value);
        }else {
          return;
        }
      }

    if(name === "AnnualIncome"){
      if (/^\d*$/.test(value)) {
        setAnnualIncome(value);
      }else {
        return;
      }
    }
    if(name === "GrossAnnualIncome"){
      if (/^\d*$/.test(value)) {
        setGrossAnnualIncome(value);
      } else {
        return;
      }
    }
    if(name === "NetWorth"){
      if (/^\d*$/.test(value)) {
        setNetWorth(value);
      }else {
        return;
      }
    }
    if(name === "DateOfBirth"){
      setDateOfBirth(value);
    }
    if(name === "DateOfAnniversary"){
      setDateOfAniversory(value);
    }
    sendDataToParent({
      ...ClientData,
      [name]: value,
    });
  }

  function handleAddressChange(e){
    let name, value;
    name = e.currentTarget.name;
    value = e.currentTarget.value;
    if(name.includes('Address') === true || name === "City" || name === "State" || name === "Country" || name === "PinNumber"){
      if(name === "PinNumber"){
        if (/^\d*$/.test(value)) {
          setPinNumber(value);
        } else {
          return;
        }
      }
      sendAddressDataToParent({
        ...ClientAddressData,
        [name]: value,
      });
    }
  }
  function addInvestmentDetail() {
    if (validateClientInvestmentDetail() === true) {
      let prevClientInvModel = [];
      let clientInvestmentModel = {
        Id: getClientInvestment.length + 1,
        ClientInvestmentId: null,
        ClientId: null,
        ClientCompanyTypeId: selectedClientCompanyTypeOption.value,
        ClientCompanyTypeName: selectedClientCompanyTypeOption.label,
        ClientCompanyId: selectedClientCompanyOption.value,
        ClientCompanyName: selectedClientCompanyOption.label
      };
      if(getClientInvestment.length > 0){
        getClientInvestment.forEach(x => {
          prevClientInvModel.push(x);
        });
      }
      prevClientInvModel.push(clientInvestmentModel);
      setClientInvestment((prevData) => [...prevData, clientInvestmentModel]);
      sendDataToParent({
        ...ClientData,
        ClientInvestment: ConvertArrayToXML(prevClientInvModel, '<ClientInvestments>','<ClientInvestment>'),
      });
      setSelectedClientCompanyTypeOption(null);
      setSelectedClientCompanyOption(null);
    }
  };

  function validateClientInvestmentDetail() {
    let validateClientInvestmentDetail = true;
    if (selectedClientCompanyTypeOption === null) {
      validateClientInvestmentDetail = false;
      CreateAlert("Please Select client company type!!", "Warning", setAlert);
    }
    if (selectedClientCompanyOption === null) {
      validateClientInvestmentDetail = false;
      CreateAlert("Please Select client company!!", "Warning", setAlert);
    }
    return validateClientInvestmentDetail;
  }

  function onDelete(row) {
    const updatedItems = getClientInvestment.filter(item => item.Id !== row.Id);
    setClientInvestment(updatedItems);
    if(updatedItems.length === 0){
      sendDataToParent({
        ...ClientData,
        ClientInvestment: null
      });
    }
  }
  function setDataOnLoad(){
    const toStr = (val) => val !== null && val !== undefined ? val.toString() : '';
    setSelectedTaxStatusOption(TaxStatusOptions.filter((x) => x.value === toStr(ClientData.TaxStatusId)));
    if(ClientData.TaxStatus === "Individual"){
      setShowTitle(true);
    } else {
      setShowTitle(false);
    }
    setSelectedModeOfHoldingOption(ModeOfHoldingOptions.filter((x) => x.value === toStr(ClientData.ModeOfHoldingId)));
    setSelectedClientRatingsOption(ClientRatingsOptions.filter((x) => x.value === toStr(ClientData.ClientRatingsId)));
    setSelectedGenderOption(GenderOptions.filter((x) => x.value === toStr(ClientData.GenderId)));
    setSelectedTitleOption(PersonTitleOptions.filter((x) => x.value === toStr(ClientData.TitleId)));
    setDateOfBirth(ClientData.DateOfBirth);
    setDateOfAniversory(ClientData.DateOfAnniversary);
    setPinNumber(ClientData.Address !== null ? ClientData.Address[0].PinNumber : "");
    fetchClientInvestments();
    setGrossAnnualIncome(ClientData.GrossAnnualIncome);
    setAnnualIncome(ClientData.AnnualIncome);
    setNetWorth(ClientData.NetWorth);
  }
  
  const fetchClientInvestments = async () => {
    try {
      let ClientDetails = {
        UserId: getStorageValues('userId'),
        ClientId: ClientData.ClientId
      };
      const response = await axios.get(getApiBaseUrl() + "/clientinvestments", {
        params: ClientDetails
      });
      if (response.status === 200) {
        setClientInvestment(response.data.data[0]);
        sendDataToParent({
          ...ClientData,
          ClientInvestment: ConvertArrayToXML(response.data.data[0], '<ClientInvestments>','<ClientInvestment>'),
        });
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchFamilyHead();
    fetchClientCompany();
    fetchClientCompanyType();
  }, []);

  // Re-run dropdown selection when master data finishes loading
  useEffect(() => {
    if (!masterLoading && TaxStatusOptions.length > 0 && ClientData && ClientData.ClientId) {
      setDataOnLoad();
    }
  }, [masterLoading, TaxStatusOptions, GenderOptions, PersonTitleOptions, ModeOfHoldingOptions, ClientRatingsOptions]);


  return (
    <>
      <SKAlerts alert={alert} />
      <div className="row">
        <div className="col-lg-3 col-sm-6 col-12">
          <div className="mb-3">
            <label className="form-label">Tax Status<span style={{ color: "red" }}>*</span></label>
            <Select
              name="TaxStatusId"
              isClearable={true}
              value={selectedTaxStatusOption ? selectedTaxStatusOption : []}
              onChange={handleChangeDropdown}
              options={TaxStatusOptions}
            />
          </div>
        </div>
        <div className="col-lg-3 col-sm-6 col-12">
          <div className="mb-3">
            <label className="form-label">Mode of Holding</label>
            <Select
              name="ModeOfHoldingId"
              isClearable={true}
              value={selectedModeOfHoldingOption ? selectedModeOfHoldingOption : []}
              onChange={handleChangeDropdown}
              options={ModeOfHoldingOptions}
            />
          </div>
        </div>
        <div className="col-lg-3 col-sm-6 col-12">
          <div className="mb-3">
            <label className="form-label">Client Ratings</label>
            <Select
              name="ClientRatingsId"
              isClearable={true}
              value={selectedClientRatingsOption ? selectedClientRatingsOption : []}
              onChange={handleChangeDropdown}
              options={ClientRatingsOptions}
            />
          </div>
        </div>
        <div className="col-lg-3 col-sm-6 col-12">
          <div className="mb-3">
            <label className="form-label">Refered By</label>
            <input
              type="text"
              className="form-control"
              name="ReferedBy"
              onChange={handleChange}
              value={ClientData.ReferedBy !== null || ClientData.ReferedBy !== undefined ? ClientData.ReferedBy : "" }
            />
          </div>
        </div>
      </div>
      <div className="accordion accordion-primary" id="accordionPrimaryExample">
        <div className="accordion-item">
          <h2 className="accordion-header" id="headingPrimaryOne">
            <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapsePrimaryOne" aria-expanded="true" aria-controls="collapsePrimaryOne">
              Personal Detail
            </button>
          </h2>
          <div id="collapsePrimaryOne" className="accordion-collapse collapse show" aria-labelledby="headingPrimaryOne" data-bs-parent="#accordionPrimaryExample">
            <div className="accordion-body">
              <div className="row">
                <div className="col-lg-2 col-sm-6 col-12" style={{ display: getShowTitle === true ? "block" : "none" }}>
                  <div className="mb-3">
                    <label className="form-label">Title<span style={{ color: "red" }}>*</span></label>
                    <Select
                      name="TitleId"
                      isClearable={true}
                      value={selectedTitleOption ? selectedTitleOption : []}
                      onChange={handleChangeDropdown}
                      options={PersonTitleOptions}
                    />
                  </div>
                </div>
                <div className={getShowTitle === true ? "col-lg-6 col-sm-6 col-12" : "col-lg-12 col-sm-6 col-12"}>
                  <div className="mb-3">
                    <label className="form-label">Client Name<span style={{ color: "red" }}>*</span></label>
                    <input
                      type="text"
                      className="form-control"
                      name="ClientName"
                      onChange={handleChange}
                      value={ClientData.ClientName !== null || ClientData.ClientName !== undefined ? ClientData.ClientName : "" }
                    />
                  </div>
                </div>
                <div className="col-lg-4 col-sm-6 col-12" style={{ display: getShowTitle === true ? "block" : "none" }}>
                  <div className="mb-3">
                    <label className="form-label">Family Head</label>
                    <Select
                      name="FamilyHeadId"
                      isClearable={true}
                      value={selectedFamilyHeadOption ? selectedFamilyHeadOption : []}
                      onChange={handleChangeDropdown}
                      options={familyHeadOptions}
                    />
                  </div>
                </div>
                <div className="col-lg-4 col-sm-6 col-12" style={{ display: getShowTitle === true ? "block" : "none" }}>
                  <div className="mb-3">
                    <label className="form-label">Gender<span style={{ color: "red" }}>*</span></label>
                    <Select
                      name="GenderId"
                      isClearable={true}
                      value={selectedGenderOption ? selectedGenderOption : []}
                      onChange={handleChangeDropdown}
                      options={GenderOptions}
                    />
                  </div>
                </div>
                <div className="col-lg-4 col-sm-6 col-12">
                  <div className="mb-3">
                    <label className="form-label">Email Id<span style={{ color: "red" }}>*</span></label>
                    <input
                      type="text"
                      className="form-control"
                      name="EmailId"
                      onChange={handleChange}
                      value={ClientData.EmailId !== null || ClientData.EmailId !== undefined ? ClientData.EmailId : ""}
                    />
                  </div>
                </div>
                <div className="col-lg-4 col-sm-6 col-12">
                  <div className="mb-3">
                    <label className="form-label">Mobile No<span style={{ color: "red" }}>*</span></label>
                    <input
                      type="text"
                      className="form-control"
                      name="MobileNumber"
                      onChange={handleChange}
                      value={getMobileNumber || ClientData.MobileNumber !== null || ClientData.MobileNumber !== undefined ? ClientData.MobileNumber : ""}
                      maxLength="10"
                    />
                  </div>
                </div>               

                <div className="row">
                  <div className="col-lg-4 col-sm-6 col-12" style={{ display: getShowTitle === true ? "block" : "none" }}>
                    <div className="input-blocks">
                      <label className="form-label">Date Of Birth<span style={{ color: "red" }}>*</span></label>
                      <div className="input-groupicon calender-input">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-calendar info-img"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg>
                        <DatePicker
                          className="datetimepicker"
                          selected={getDateOfBirth}
                          onChange={(date) => handleChange(date,"DateOfBirth")} 
                          name="DateOfBirth"
                          dateFormat="dd/MM/yyyy"
                          showMonthDropdown
                          showYearDropdown
                          dropdownMode="select"
                          disabledKeyboardNavigation
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4 col-sm-6 col-12" style={{ display: getShowTitle === true ? "block" : "none" }}>
                    <div className="input-blocks">
                      <label className="form-label">Date Of Anniversary</label>
                      <div className="input-groupicon calender-input">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-calendar info-img"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg>
                        <DatePicker
                          className="datetimepicker"
                          selected={getDateOfAniversory}
                          onChange={(date) => handleChange(date,"DateOfAnniversary")} 
                          name="DateOfAnniversary"
                          dateFormat="dd/MM/yyyy"
                          showMonthDropdown
                          showYearDropdown
                          dropdownMode="select"
                          disabledKeyboardNavigation
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4 col-sm-6 col-12" style={{ display: getShowTitle === true ? "block" : "none" }}>
                    <div className="mb-3">
                      <label className="form-label">Place Of Birth</label>
                      <input
                        type="text"
                        className="form-control"
                        name="PlaceOfBirth"
                        onChange={handleChange}
                        value={ClientData.PlaceOfBirth !== null || ClientData.PlaceOfBirth !== undefined ? ClientData.PlaceOfBirth : ""}
                      />
                    </div>
                  </div>
                  <div className="col-lg-4 col-sm-6 col-12" style={{ display: getShowTitle === true ? "block" : "none" }}>
                    <div className="mb-3">
                      <label className="form-label">Country Of Birth</label>
                      <input
                        type="text"
                        className="form-control"
                        name="CountryOfBirth"
                        onChange={handleChange}
                        value={ClientData.CountryOfBirth !== null || ClientData.CountryOfBirth !== undefined ? ClientData.CountryOfBirth : ""}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 col-sm-6 col-12">
                  <div className="mb-3">
                    <label className="form-label">Occupation</label>
                    <input
                      type="text"
                      className="form-control"
                      name="Occupation"
                      onChange={handleChange}
                      value={ClientData.Occupation !== null || ClientData.Occupation !== undefined ? ClientData.Occupation : ""}
                    />
                  </div>
                </div>
                <div className="col-lg-4 col-sm-6 col-12">
                  <div className="mb-3">
                    <label className="form-label">PAN Number<span style={{ color: "red" }}>*</span></label>
                    <input
                      type="text"
                      className="form-control"
                      name="PANNo"
                      onChange={handleChange}
                      value={ClientData.PANNo !== null || ClientData.PANNo !== undefined ? ClientData.PANNo : ""}
                    />
                  </div>
                </div>
                <div className="col-lg-4 col-sm-6 col-12">
                  <div className="mb-3">
                    <label className="form-label">Nominee</label>
                    <input
                      type="text"
                      className="form-control"
                      name="Nominee"
                      onChange={handleChange}
                      value={ClientData.Nominee !== null || ClientData.Nominee !== undefined ? ClientData.Nominee : ""}
                    />
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
        <div className="accordion-item">
          <h2 className="accordion-header" id="headingPrimaryTwo">
            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapsePrimaryTwo" aria-expanded="false" aria-controls="collapsePrimaryTwo">
              Address Details
            </button>
          </h2>
          <div id="collapsePrimaryTwo" className="accordion-collapse collapse" aria-labelledby="headingPrimaryTwo" data-bs-parent="#accordionPrimaryExample">
            <div className="accordion-body">
              <div className="row">
              <div className="col-lg-4 col-sm-6 col-12">
                  <div className="input-blocks summer-description-box transfer mb-3">
                    <label>Address #1</label>
                    <textarea
                      className="form-control h-100"
                      name="AddressLine1"
                      rows={3}
                      cols={40}
                      onChange={handleAddressChange}
                      value={ClientAddressData.AddressLine1 !== null || ClientAddressData.AddressLine1 !== undefined ? ClientAddressData.AddressLine1 : ""}
                    />
                    <p className="mt-1">Maximum 60 Characters</p>
                  </div>
                </div>
                <div className="col-lg-4 col-sm-6 col-12">
                  <div className="input-blocks summer-description-box transfer mb-3">
                    <label>Address #2</label>
                    <textarea
                      className="form-control h-100"
                      name="AddressLine2"
                      rows={3}
                      cols={40}
                      onChange={handleAddressChange}
                      value={ClientAddressData.AddressLine2 !== null || ClientAddressData.AddressLine2 !== undefined ? ClientAddressData.AddressLine2 : ""}
                    />
                    <p className="mt-1">Maximum 60 Characters</p>
                  </div>
                </div>
                <div className="col-lg-4 col-sm-6 col-12">
                  <div className="input-blocks summer-description-box transfer mb-3">
                    <label>Address #3</label>
                    <textarea
                      className="form-control h-100"
                      name="AddressLine3"
                      rows={3}
                      cols={40}
                      onChange={handleAddressChange}
                      value={ClientAddressData.AddressLine3 !== null || ClientAddressData.AddressLine3 !== undefined ? ClientAddressData.AddressLine3 : ""}
                    />
                    <p className="mt-1">Maximum 60 Characters</p>
                  </div>
                </div>
                <div className="col-lg-3 col-sm-6 col-12">
                  <div className="mb-3">
                    <label className="form-label">City</label>
                    <input
                      type="text"
                      className="form-control"
                      name="City"
                      onChange={handleAddressChange}
                      value={ClientAddressData.City !== null || ClientAddressData.City !== undefined ? ClientAddressData.City : ""}
                    />
                  </div>
                </div>
                <div className="col-lg-3 col-sm-6 col-12">
                  <div className="mb-3">
                    <label className="form-label">State</label>
                    <input
                      type="text"
                      className="form-control"
                      name="State"
                      onChange={handleAddressChange}
                      value={ClientAddressData.State !== null || ClientAddressData.State !== undefined ? ClientAddressData.State : ""}
                    />
                  </div>
                </div>
                <div className="col-lg-3 col-sm-6 col-12">
                  <div className="mb-3">
                    <label className="form-label">Country</label>
                    <input
                      type="text"
                      className="form-control"
                      name="Country"
                      onChange={handleAddressChange}
                      value={ClientAddressData.Country !== null || ClientAddressData.Country !== undefined ? ClientAddressData.Country : ""}
                    />
                  </div>
                </div>
                <div className="col-lg-3 col-sm-6 col-12">
                  <div className="mb-3">
                    <label className="form-label">Pin No</label>
                    <input
                      type="text"
                      className="form-control"
                      name="PinNumber"
                      onChange={handleAddressChange}
                      value={getPinNumber ?? ''}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="accordion-item">
          <h2 className="accordion-header" id="headingPrimaryThree">
            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapsePrimaryThree" aria-expanded="false" aria-controls="collapsePrimaryThree">
              Investment Company/Category
            </button>
          </h2>
          <div id="collapsePrimaryThree" className="accordion-collapse collapse" aria-labelledby="headingPrimaryThree" data-bs-parent="#accordionPrimaryExample">
            <div className="accordion-body">
              <div className="row">
                <div className="col-lg-3 col-sm-6 col-12">
                  <div className="mb-3">
                    <label className="form-label">Client Company Type</label>
                    <Select
                      name="ClientCompanyTypeId"
                      value={selectedClientCompanyTypeOption ? selectedClientCompanyTypeOption : []}
                      isClearable={true}
                      options={getClientCompanyTypeOptions || []}
                      onChange={handleChangeDropdown}
                    />
                  </div>
                </div>

                <div className="col-lg-4 col-sm-6 col-12">
                  <div className="input-blockss">
                    <label className="form-label">Client Company</label>
                    <div className="row">
                      <div className="col-lg-10 col-sm-10 col-10">
                        <Select
                          name="ClientCompanyId"
                          value={selectedClientCompanyOption ? selectedClientCompanyOption : []}
                          isClearable={true}
                          options={getClientCompanyOptions || []}
                          onChange={handleChangeDropdown}
                        />
                      </div>
                      <div className="col-lg-2 col-sm-2 col-2 ps-0">
                        <div className="add-icon">
                          <button className="btn btn-submit ddbtnicon" onClick={addInvestmentDetail}><Icons.PlusCircle size={18} className="me-2" /> Add </button>                         
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <ClientInvestmentGrid onDelete={onDelete} ClientInvestmentData={getClientInvestment.length > 0 ? getClientInvestment : undefined} />
            </div>
          </div>
        </div>
        <div className="accordion-item">
          <h2 className="accordion-header" id="headingPrimaryFour">
            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapsePrimaryFour" aria-expanded="false" aria-controls="collapsePrimaryFour">
              Other Details
            </button>
          </h2>
          <div id="collapsePrimaryFour" className="accordion-collapse collapse" aria-labelledby="headingPrimaryFour" data-bs-parent="#accordionPrimaryExample">
            <div className="accordion-body">
              <div className="row">
                <div className="col-lg-4 col-sm-6 col-12">
                  <div className="mb-3">
                    <label className="form-label">DP ID</label>
                    <input
                      type="text"
                      className="form-control"
                      name="DPId"
                      onChange={handleChange}
                      value={ClientData.DPId !== null || ClientData.DPId !== undefined ? ClientData.DPId : ""}
                    />
                  </div>
                </div>
                <div className="col-lg-4 col-sm-6 col-12">
                  <div className="mb-3">
                    <label className="form-label">NPS A/C No</label>
                    <input
                      type="text"
                      className="form-control"
                      name="NPSAccountNumber"
                      onChange={handleChange}
                      value={ClientData.NPSAccountNumber !== null || ClientData.NPSAccountNumber !== undefined ? ClientData.NPSAccountNumber : ""}
                    />
                  </div>
                </div>
                <div className="col-lg-4 col-sm-6 col-12">
                  <div className="mb-3">
                    <label className="form-label">Annual Income</label>
                    <input
                      type="text"
                      className="form-control"
                      name="AnnualIncome"
                      onChange={handleChange}
                      value={getAnnualIncome}
                    />
                  </div>
                </div>
                <div className="col-lg-4 col-sm-6 col-12">
                  <div className="mb-3">
                    <label className="form-label">Gross Annual Income</label>
                    <input
                      type="text"
                      className="form-control"
                      name="GrossAnnualIncome"
                      onChange={handleChange}
                      value={getGrossAnnualIncome}
                    />
                  </div>
                </div>
                <div className="col-lg-4 col-sm-6 col-12">
                  <div className="mb-3">
                    <label className="form-label">Net Worth</label>
                    <input
                      type="text"
                      className="form-control"
                      name="NetWorth"
                      onChange={handleChange}
                      value={getNetWorth}
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-4 col-sm-6 col-12">
                  <div className="mb-3">
                    <label className="form-label">Bank Name</label>
                    <input
                      type="text"
                      className="form-control"
                      name="BankName"
                      onChange={handleChange}
                      value={ClientData.BankName !== null || ClientData.BankName !== undefined ? ClientData.BankName : ""}
                    />
                  </div>
                </div>
                <div className="col-lg-4 col-sm-6 col-12">
                  <div className="mb-3">
                    <label className="form-label">Branch Name</label>
                    <input
                      type="text"
                      className="form-control"
                      name="BranchName"
                      onChange={handleChange}
                      value={ClientData.BranchName !== null || ClientData.BranchName !== undefined ? ClientData.BranchName : ""}
                    />
                  </div>
                </div>
                <div className="col-lg-4 col-sm-6 col-12">
                  <div className="mb-3">
                    <label className="form-label">Account No</label>
                    <input
                      type="text"
                      className="form-control"
                      name="AccountNumber"
                      onChange={handleChange}
                      value={ClientData.AccountNumber !== null || ClientData.AccountNumber !== undefined ? ClientData.AccountNumber : ""}
                    />
                  </div>
                </div>
                <div className="col-lg-4 col-sm-6 col-12">
                  <div className="mb-3">
                    <label className="form-label">IFSC Code</label>
                    <input
                      type="text"
                      className="form-control"
                      name="IFSCCode"
                      onChange={handleChange}
                      value={ClientData.IFSCCode !== null || ClientData.IFSCCode !== undefined ? ClientData.IFSCCode : ""}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default EditClient